export default "__VITE_ASSET__DnQP$AbZ__"